<template>
  <div class="schedule" >
    <el-divider content-position="left">合格信息表统计</el-divider>
    <el-collapse v-model="activeOpen">
      <el-collapse-item title="高级筛选">
        <div style="padding: 10px">
          <el-row class="mb-20 search-row" :gutter=20>
            <el-col :span="2" style="margin-top: .05rem;"><span>合格日期</span></el-col>
            <el-col :span="8">
              <el-date-picker v-model="searchArr.dispatchDate" type="datetimerange" align="right" unlink-panels
                range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                :picker-options="typeInPickerOptions" :default-time="['00:00:00', '23:59:59']"
                value-format="yyyy-MM-dd HH:mm:ss" size="mini" @change="goToGetResult">
              </el-date-picker>
            </el-col>
            <el-col :span="2" :offset="1" style="margin-top: .05rem;"><span>业务人员</span></el-col>
            <el-col :span="5">
              <el-cascader
                  style="width: 200px;"
                  v-model="searchArr.consultant"
                  placeholder="请选择业务人员"
                  :options="personnel"
                  size="mini"
                  :props="{ expandTrigger: 'hover' }"
                  clearable
                  filterable
                  :filter-method="filterOptions"
                  >
                </el-cascader>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="2" style="margin-top: .05rem;"><span>角色选择</span></el-col>
            <el-col :span="21">
              <el-select @change="getRoleSelected" v-model="searchArr.role_id" placeholder="请选择" filterable
                clearable size="mini" multiple style="width: 100%;" @click.native="loadRole">
                <el-option v-for="user in roleOptions" :key="user.id" :label="user.role_name"
                    :value="user.id"></el-option>
            </el-select>
            </el-col>
          </el-row>
          <div style="padding-left:  0.3rem;" v-if="searchArr.role_id.length > 0">
              <div style="margin-top: .2rem;">
                  <el-checkbox v-model="chooseAll" @change="chooseAllChange">全选</el-checkbox>
                  <el-checkbox v-model="chooseAllReverse" @change="chooseAllReverseChange" style="color:#e6a23c">反选</el-checkbox>
              </div>
              <div v-for="item in RoleAdminUserOptions" :key="item.id" style="margin-top: 0.2rem;">
                  <div>{{ item.role_name }}</div>
                  <div style="display: inline-block;text-align: left;width: 100px;overflow:hidden;padding: 0 0.2rem;"
                      v-for="i in item.users" :key="i.id">
                      <el-tooltip class="item" effect="dark" :content="i.username" placement="top" :open-delay="500">
                          <el-checkbox @change="clearAllAndReverse" v-model="searchArr.chBox[i.id]">{{ i.username }}</el-checkbox>
                      </el-tooltip>
                  </div>
              </div>
          </div>
          <el-row style="text-align: center;margin-top: .4rem;">
            <el-button type="primary" size="mini" @click="handleASearSub">查询</el-button>
            <el-button type="danger" size="mini" @click="handleASearClear">清除</el-button>
          </el-row>
        </div>
      </el-collapse-item>
    </el-collapse>
    <el-row :span="24" style="height: 1rem;line-height: 1rem;">
      合格日期：{{start_date}}&nbsp;&nbsp;/&nbsp;&nbsp;{{ end_date }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;有限公司总和:{{ limit_total }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;个人独资总和:{{ sole_total }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;个人独资占比:{{ (sole_total / (sole_total + limit_total)) * 100 | toFixedTwo }}%
    </el-row>
    <el-table :data="orders" border size="medium" :show-summary="true" style="width: 100%" v-cloak>
      <el-table-column label="业务员" width="60" prop="username">
        <template slot-scope="scope">
          <span>{{ scope.row.username }}</span>
        </template>
      </el-table-column>
      <el-table-column label="有限公司" width="100" prop="limit_num">
        <template slot-scope="scope">
          <div class="number-cell" @click="handleOpenSoleDetail(scope.row.user_id, '有限公司', scope.row.limit_num)">
            {{ scope.row.limit_num }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="个人独资" width="100" prop="sole_num" >
        <template slot-scope="scope">
          <div class="number-cell" @click="handleOpenSoleDetail(scope.row.user_id, '个人独资', scope.row.sole_num)">
            {{ scope.row.sole_num }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="个人独资占比" width="100">
        <template slot-scope="scope">
          <div class="number-cell">
            <el-tag effect="plain" style="font-size: 16px;" v-if="scope.row.limit_num !== 0">
              {{ (scope.row.sole_num / (scope.row.sole_num + scope.row.limit_num) * 100) | toFixedTwo }}%
            </el-tag>
            <el-tag effect="plain" style="font-size: 16px;" v-else>
              0.00%
            </el-tag>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!-- 类型弹窗 -->
    <el-drawer title="注册信息表详情" :visible.sync="typeDetailDrawer" direction="rtl" size="70%">
      <el-table :data="typeDetail" border size="medium" style="width: 98%;margin: 0 auto;" v-cloak>
        <el-table-column label="业务员" width="80" :header-align="'center'">
          <template slot-scope="scope">
            <span>{{ scope.row.advisor.username }}</span>
          </template>
        </el-table-column>
        <el-table-column label="订单编号" :render-header="renderHeader" width="120" :header-align="'center'">
          <template slot-scope="scope">
            <el-link class="ellipsis-link" type="primary" @click="handleOrderInfoOpen(scope.row.id)">{{ scope.row.order_num }}</el-link>
          </template>
        </el-table-column>
        <el-table-column label="注册类型" width="auto" :header-align="'center'">
          <template slot-scope="scope">
            <span>{{ scope.row.actual_reg_type === 7 ? '有限公司': '个人独资' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="信息表整理时间" width="140" prop="organizer_at" :header-align="'center'">
          <template slot-scope="scope">
            <date-formatter :date-value="scope.row.organizer_at"></date-formatter>
          </template>
        </el-table-column>
        <el-table-column label="派单时间" width="140" prop="assign_at" :header-align="'center'">
          <template slot-scope="scope">
            <date-formatter :date-value="scope.row.assign_at"></date-formatter>
          </template>
        </el-table-column>
        <el-table-column label="分配顾问时间" width="140" prop="assign_chater_time" :header-align="'center'">
          <template slot-scope="scope">
            <date-formatter :date-value="scope.row.assign_chater_time"></date-formatter>
          </template>
        </el-table-column>
        <el-table-column label="对接时长" width="140" prop="time" :header-align="'center'"></el-table-column>
        <el-table-column label="合格通过人" width="100" :header-align="'center'">
          <template slot-scope="scope">
            <span>{{ scope.row.info_excel_log[0].adminer.username }}</span>
          </template>
        </el-table-column>
        <el-table-column label="合格通过时间" width="140" prop="doc_timed" :header-align="'center'">
          <template slot-scope="scope">
            <date-formatter :date-value="scope.row.doc_timed"></date-formatter>
          </template>
        </el-table-column>
      </el-table>
      <div class="total-class">
        总计：{{ detailTotal }}
      </div>
    </el-drawer>
    <el-drawer title="订单信息" :visible.sync="orderInfoVisible" direction="rtl" size="50%"
      :before-close="handleOrderInfoClose">
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <order-info :orderId="orderInfoId"></order-info>
      </div>
    </el-drawer>
  </div>
</template>

<script>

import OrderInfo from 'common/OrderInfo'
import Vue from 'vue'
import { filterKeywordOptions } from '../../lib/cascaderUtils.js';
import DateFormatter from "common/DateFormatter";

export default {
  name: 'RegmationCount',
  components: {
    OrderInfo,
    DateFormatter
  },
  data() {
    return {
      activeOpen: '',
      searchArr: {
        consultant: [],
        role_id: '',
        dispatchDate: null,
        chBox: [],
      },
      personnel: [],
      orders: [],
      inputSize: 'small',
      typeDetail: [],
      typeDetailDrawer: false,
      orderInfoVisible: false,
      orderInfoId: null,
      sole_total: 0,
      limit_total: 0,
      detailTotal: 0,
      RoleAdminUserOptions: [],
      roleOptions: [],
      chooseAll: false,
      chooseAllReverse: false,
      start_date: '',
      end_date: '',
    }
  },
  filters: {
    toFixedTwo(value) {
      const num = parseFloat(value); // 将 value 转换为浮点型数值
      if (isNaN(num)) {
        return '0.00';  // 如果无法转换为数字，则返回 '0.00'
      } else {
        return (num === 0) ? '0.00' : num.toFixed(2); // 如果 num 为零，则返回 '0.00'，否则保留两位小数
      }
    }
  },
  computed: {
    actionHost: {
      get: function () {
        return process.env.NODE_ENV === 'development'
          ? ''
          : 'https://weixin.qiyehuo.com'
      },
    },
    searchStr: function () {
      let str = ''
      for (let key in this.searchArr) {
        str += '&' + key + '=' + this.searchArr[key]
      }

      return str
    },
    typeInPickerOptions: function () {
      var _this = this
      return {
        shortcuts: [
          {
            text: '今天',
            onClick(picker) {
              const todayDate = new Date().toLocaleDateString()
              var dateArr = _this.nowDate(todayDate)
              const start = new Date(
                dateArr[0],
                dateArr[1] - 1,
                dateArr[2],
                0,
                0,
                0
              )
              const end = new Date(
                dateArr[0],
                dateArr[1] - 1,
                dateArr[2],
                23,
                59,
                59
              )
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '昨天',
            onClick(picker) {
              const dd = new Date()
              dd.setDate(dd.getDate() - 1)
              var yesterDate = dd.toLocaleDateString()
              var dateArr = _this.nowDate(yesterDate)
              const start = new Date(
                dateArr[0],
                dateArr[1] - 1,
                dateArr[2],
                0,
                0,
                0
              )
              const end = new Date(
                dateArr[0],
                dateArr[1] - 1,
                dateArr[2],
                23,
                59,
                59
              )
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '本周',
            onClick(picker) {
              var now = new Date()
              const year = now.getFullYear()
              const month = now.getMonth()
              const day = now.getDate()
              const week = now.getDay()

              let start = new Date(year, month, day - week + 1, 0, 0, 0)
              let end = new Date(year, month, day - week + 7, 23, 59, 59)

              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '上周',
            onClick(picker) {
              var dateS = _this.getWeek(-1, 0).split('-')
              var dateE = _this.getWeek(-1, 1).split('-')

              let start = new Date(dateS[0], dateS[1] - 1, dateS[2], 0, 0, 0)
              let end = new Date(dateE[0], dateE[1] - 1, dateE[2], 23, 59, 59)

              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '本月',
            onClick(picker) {
              var str = _this.getCurrentDate()

              var arr = _this.getfirstDateAndlastDate(str)

              var arrS = arr[0].split('-')
              var arrE = arr[1].split('-')

              var start = new Date(arrS[0], arrS[1] - 1, arrS[2], 0, 0, 0)
              var end = new Date(arrE[0], arrE[1] - 1, arrE[2], 23, 59, 59)

              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '上个月',
            onClick(picker) {
              var str = _this.fromLastMonth()

              var arr = _this.getfirstDateAndlastDate(str)

              var arrS = arr[0].split('-')
              var arrE = arr[1].split('-')

              var start = new Date(arrS[0], arrS[1] - 1, arrS[2], 0, 0, 0)
              var end = new Date(arrE[0], arrE[1] - 1, arrE[2], 23, 59, 59)

              picker.$emit('pick', [start, end])
            },
          },
        ],
      }
    },
    collapse() {
      return this.$store.state.collapse
    },
  },
  methods: {
    handelGetOrders() {
      this.$axios
        .get('/api/admin/other_orders/count_regmation', {
          params: {
            searchItem: this.searchArr
          }
        })
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.orders = data.list
            this.sole_total = data.sole_total
            this.limit_total = data.limit_total
            this.personnel = data.personnel
            this.start_date = data.start_date
            this.end_date = data.end_date
          }
        })
    },
    calculateSummary(params) {
      console.log(params)
      const { columns, data } = params;
      const summary = {};

      // 初始化合计行数据
      for (let i = 0; i < columns.length; i++) {
        const prop = columns[i].property;
        summary[prop] = 0;
      }

      // 计算个人独资占比的总和
      let soleSum = 0;
      for (let i = 0; i < data.length; i++) {
        soleSum += data[i].sole_num;
      }

      // 计算有限公司的总和
      let limitSum = 0;
      for (let i = 0; i < data.length; i++) {
        limitSum += data[i].limit_num;
      }

      // 计算个人独资占比
      const personalRatio = (soleSum / (soleSum + limitSum)) * 100;

      // 设置合计行数据
      summary.sole_num = soleSum;
      summary.limit_num = limitSum;
      summary.personal_ratio = personalRatio.toFixed(2) + '%';

      return [summary]; // 返回合计行数据供表格显示
    },
    getRoleSelected(val) {
      this.RoleAdminUserOptions = []
        if (val.length === 0) {
            this.searchArr.chBox = []
            return false
        }
        this.$axios.get('api/ysy_count_get_role_adminuser', {
            params: {
                role_ids: val
            }
        }).then(({ data }) => {
            if (data.code === 200) {
                this.RoleAdminUserOptions = data.data
                this.showChBox()
            }
        }).catch()
    },
    showChBox () {
      this.searchArr.chBox = []
      this.RoleAdminUserOptions.map(item => {
          item.users.map(i => {
              Vue.set(this.searchArr.chBox, i.id, false)
          }) 
      })
    },
    loadRole() {
      this.$axios
          .get('api/ysy_count_get_role')
          .then(({ data }) => {
              if (data.code === 200) {
                this.roleOptions = data.data
              }
          })
          .catch()
    },
    chooseAllChange(val) {
        if (val === true) {
            this.chooseAllReverse = false
            this.searchArr.chBox.map((item,index,o) => {
                o[index] = true
            })
        }
    },
    chooseAllReverseChange(val) {
        if (val === true) {
            this.chooseAll = false
            this.searchArr.chBox.map((item,index,o) => {
                o[index] = o[index] === true ? false : true
            })
        }
    },
    clearAllAndReverse () {
        this.chooseAll = false
        this.chooseAllReverse = false
    },
    handleOpenSoleDetail(userId, type, num) {
      if (num === 0) {
        return
      }
      this.$axios
        .post('/api/admin/other_orders/get_type_detail', {userId: userId, type: type, param: this.searchArr})
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            // console.log(data);return
            this.typeDetail = data.data.tycTypeOrders
            this.detailTotal = data.data.tycTypeOrders.length
            this.typeDetailDrawer = true
          }
        })
    },
    // getSummaries(param) {
    //   console.log(param)
    //   const { columns, data } = param;
    //     const sums = [];
    //     // console.log(columns);
    //     columns.forEach((column, index) => {
    //       if (index === 0) {
    //         sums[index] = '合计';
    //         return;
    //       }

    //       const values = data.map(item => Number(item[column.property]));
    //       if (!values.every(value => isNaN(value))) {
    //         sums[index] = values.reduce((prev, curr) => {
    //           const value = Number(curr);
    //           if (!isNaN(value)) {
    //             return prev + curr;
    //           } else {
    //             return prev;
    //           }
    //         }, 0);
    //         sums[index] += '';
    //       } 
    //       else {
    //         sums[index] = 'N/A';
    //       }
    //     });

    //     return sums;
    // },
    handleOrderInfoOpen(orderId) {
      this.orderInfoVisible = true
      setTimeout(() => {
        this.orderInfoId = orderId
      })
    },
    handleOrderInfoClose(done) {
      this.orderInfoId = null
      done()
    },
    renderHeader(h, { column }) {
      // 共用的表头
      return h('span', column.label);
    },
    goToGetResult(val) {
      this.searchArr.dispatchDate = val
    },
    nowDate(date) {
      return date.split('/')
    },
    getWeek(n, type) {
      // 周
      let now = new Date()
      let day = now.getDay() // 返回星期几的某一天;
      if (!type) {
        if (n === 1) {
          let dayNumber = day === 0 ? 0 : 7 - day
          now.setDate(now.getDate() + dayNumber + 1)
        } else if (n === -1) {
          let dayNumber = day === 0 ? 6 : day - 1
          now.setDate(now.getDate() - dayNumber - 7)
        } else {
          let dayNumber = day === 0 ? 6 : day - 1
          now.setDate(now.getDate() - dayNumber)
        }
      } else {
        if (n === 1) {
          let dayNumber = day === 0 ? 0 : 7 - day
          now.setDate(now.getDate() + dayNumber + 1 + 6) // 在周开始的日期上+6天=周结束
        } else if (n === -1) {
          let dayNumber = day === 0 ? 6 : day - 1
          now.setDate(now.getDate() - dayNumber - 7 + 6)
        } else {
          let dayNumber = day === 0 ? 0 : 7 - day
          now.setDate(now.getDate() + dayNumber)
        }
      }
      let date = now.getDate()
      let month = now.getMonth() + 1

      let s =
        now.getFullYear() +
        '-' +
        (month < 10 ? '0' + month : month) +
        '-' +
        (date < 10 ? '0' + date : date)
      return s
    },
    getfirstDateAndlastDate(dateC) {
      var dateStr = dateC
      var date = new Date(dateStr)
      var year = date.getFullYear()
      var month = date.getMonth() + 1
      if (month > 12) {
        month = 1
        year++
      }
      if (month < 10) {
        month = '0' + month
      }
      var monthLastDay = new Date(year, month, 0).getDate()
      var firstDate = year + '-' + month + '-' + '01'
      var lastDate = year + '-' + month + '-' + monthLastDay
      return [firstDate, lastDate]
    },
    getCurrentDate() {
      var date = new Date()
      var seperator1 = '-'
      var year = date.getFullYear()
      var month = date.getMonth() + 1
      var strDate = date.getDate()
      if (month >= 1 && month <= 9) {
        month = '0' + month
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = '0' + strDate
      }
      var currentdate = year + seperator1 + month + seperator1 + strDate
      return currentdate
    },
    fromLastMonth() {
      var date = new Date()
      var lastMonthDate = ''
      // 获取当前几号，如果小于10则补0
      var day = date.getDate()
      if (day < 10) {
        day = '0' + day
      }
      var month = date.getMonth()
      var year = date.getFullYear()
      // 上个月小于1则证明跨年，年份减1
      if (month < 1) {
        lastMonthDate = year - 1 + '-12-' + day
      } else {
        // 月份小于10则补0
        if (month < 10) {
          month = '0' + month
        }
        lastMonthDate = year + '-' + month + '-' + day
      }
      return lastMonthDate
    },
    handleASearSub() {
      this.activeOpen = ''
      this.handelGetOrders()
    },
    handleASearClear() {
      this.activeOpen = ''
      this.searchArr.consultant = []
      this.searchArr.dispatchDate = null
      this.handelGetOrders()
    },
    handleClickCollapseOutSide(event) {
      const elCollapse = this.$el.querySelector('.el-collapse');
      if (elCollapse && !elCollapse.contains(event.target)) {
        this.activeOpen = '';
      }
    },
    filterOptions(node, keyword) {
  return filterKeywordOptions(node, keyword);
}
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickCollapseOutSide);
  },
  mounted() {
    this.handelGetOrders()
    document.addEventListener('click', this.handleClickCollapseOutSide);
  },
}
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl';
@import '~styles/vertical.styl';

[v-cloak] {
  display: none;
}

.ellipsis-link {
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.number-cell {
  position: relative;
  width: 100%;
  height: 100%;
  cursor: pointer;
}

.total-class {
  margin: .4rem 0 0 .4rem;
}

.number-cell::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.setBadge >>> .el-badge__content.is-fixed {
  top: 0.22rem;
  right: 0.06rem;
}

.el-drawer__wrapper >>> .el-drawer {
  overflow-y: auto;
}

.schedule >>> .el-drawer__header {
  font-size: 0.36rem;
  font-weight: 400;
  color: #4D84FE;
}

.schedule >>> .el-table__header th {
  color: #333333;
}

.schedule >>> .el-timeline-item__node--normal {
  left: 0;
  background-color: #ECF4FF;
}

.el-select, .el-cascader {
  width: 100%;
}

.schedule {
  marginLeft();

  .count-style {
    display: inherit;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.clearfix:before, .clearfix:after {
  display: table;
  content: '';
}

.clearfix:after {
  clear: both;
}

.search-row .el-col {
  margin-bottom: 0.2rem;
}

.count {
  padding-left: 0.2rem;
  line-height: 0.56rem;
}

.el-collapse {
  border-bottom: 0;
  border-top: 0;
}

.el-collapse >>> .el-collapse-item__header {
  color: #4C87FC;
  font-weight: bold;
}

.el-collapse >>> .el-collapse-item__arrow {
  color: #4C87FC;
}

.tr {
  text-align: right;
}

.mt-50 {
  margin-top: 1rem;
}

.mt-10 {
  margin-top: 0.2rem;
}

.mb-10 {
  margin-bottom: 0.2rem;
}

.m-tabs-content {
  padding: 0 0.2rem 0 0.4rem;

  .tabs-title {
    color: #5789F4;
  }

  .m-label {
    line-height: 0.64rem;
  }

  .el-row {
    margin-bottom: 0.4rem;
  }

  .el-date-editor.el-input, .el-date-editor.el-input__inner {
    width: 100%;
  }
}

.el-date-editor {
  width: 100% !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/customer/RegmationCount.vue